import { Alert, Button, Form, Input, Select, Tag } from 'antd';
import DatePicker from 'common/ui/UIDatePicker';
import { useEffect } from 'react';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';
import { convertDateFormData, ensureDateFields } from 'utils/formData';
import { EVENT_TYPE_OPTIONS, eventTypeLabel } from './config';

const { TextArea } = Input;

const dateFields = ['announce_date', 'record_date', 'execute_date'];

// The API skips null fields on PATCH but clears a field sent as '', so cleared
// dates and type must go out as '' or the old value stays.
const clearableFields = [...dateFields, 'event_type'];

const toSubmitValues = values => {
  const data = convertDateFormData(values, dateFields);
  clearableFields.forEach(key => {
    if (data[key] == null) data[key] = '';
  });
  return data;
};

const StockEventForm = ({
  form,
  submiting,
  onFinish,
  initialValues = {} as Record<string, any>,
  name,
}) => {
  useEffect(() => {
    form.setFieldsValue(ensureDateFields(initialValues, dateFields));
  }, [form, initialValues]);

  // Picking a type fills in its Wifeed label, as the sync does.
  const onEventTypeChange = value => {
    const label = eventTypeLabel(value);
    if (label) form.setFieldValue('event_type_label', label);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'stock_event_form'}
      onFinish={values => {
        onFinish(toSubmitValues(values));
      }}
      initialValues={ensureDateFields(initialValues, dateFields)}
      scrollToFirstError
    >
      <Form.Item {...tailFormItemLayout}>
        <Alert
          type="warning"
          showIcon
          message="Events are synced daily from Wifeed: the next sync overwrites manual changes to events Wifeed still returns."
        />
      </Form.Item>
      {initialValues?.symbol && (
        <Form.Item label="Symbol">
          <Tag color="blue">{initialValues.symbol}</Tag>
        </Form.Item>
      )}
      <Form.Item name="event_type" label="Event Type">
        <Select
          allowClear
          placeholder="Select event type"
          options={EVENT_TYPE_OPTIONS}
          onChange={onEventTypeChange}
        />
      </Form.Item>
      <Form.Item
        name="event_type_label"
        label="Event"
        rules={[{ required: true, message: 'Please enter the event' }]}
      >
        <Input placeholder="Trả cổ tức bằng tiền mặt" />
      </Form.Item>
      <Form.Item name="title" label="Title">
        <TextArea rows={2} />
      </Form.Item>
      <Form.Item name="announce_date" label="Announce Date">
        <DatePicker format="DD/MM/YYYY" />
      </Form.Item>
      <Form.Item name="record_date" label="Record Date">
        <DatePicker format="DD/MM/YYYY" />
      </Form.Item>
      <Form.Item name="execute_date" label="Execute Date">
        <DatePicker format="DD/MM/YYYY" />
      </Form.Item>
      <Form.Item name="event_url" label="Document URL">
        <Input placeholder="https://" />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default StockEventForm;
